import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../../constants';
import '../Antrag.css'

const PaymentResult: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [message, setMessage] = useState<string>('');
    const [status, setStatus] = useState<string>('');
    const errorHandled = useRef(false); // needed for development in strict mode

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const checkoutStatus = queryParams.get('checkout');
        setStatus(checkoutStatus || '');
        const antragId = queryParams.get('antragId');

        if (checkoutStatus === 'success' && !errorHandled.current) {
            setMessage('Vielen Dank für die Bezahlung der Nostrifizierungstaxe. Ihr Antrag wurde erfolgreich eingereicht!');
        } else if (checkoutStatus === 'canceled') {
            setMessage('Leider konnte die Bezahlung nicht abgeschlossen werden. Ihr Antrag konnte nicht erfolgreich eingereicht werden!');
            errorHandled.current = true;
            handlePaymentError(Number(antragId));
        } else {
            setMessage('Unbekannter Zahlungsstatus. Bitte kontaktieren Sie den Support.');
        }

        setTimeout(() => {
            navigate('/dashboard', {
                state: {
                    payment: checkoutStatus === 'success' ? 'success' : 'canceled'
                }
            });
        }, 5000);
    }, [location.search, navigate]);


    const handlePaymentError = async (antragId: number) => {
        try {
            await axios.post(`${API_BASE_URL}/payment-error/${antragId}`, {}, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            });
        } catch (error) {
            console.error('Error handling payment error:', error);
        }
    };

    return (
        <div>
            <p style={{
                textAlign: "center",
                fontSize: "18px",
                marginTop: "30px",
                fontWeight: "bold",
                color: status === 'canceled' ? '#d32f2f' : 'black'
            }}>
                {message}
            </p>
            <p style={{ textAlign: "center", fontSize: "16px", marginTop: "10px" }}>
                Sie werden in Kürze weitergeleitet
                <span>  </span>
                <span className="loading-dot">.</span>
                <span className="loading-dot">.</span>
                <span className="loading-dot">.</span>
            </p>
        </div>
    );
};

export default PaymentResult;